module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/chevronRightGrayDouble.1a8f49ed.svg";